export const SCROLL_DIRECTION = {
  UP: 'up',
  DOWN: 'down',
  NONE: 'none',
};

export const SCROLL_THRESHOLD_PIXELS = 50;
